import { UnitsFilterDto } from "app/shared/model/DiscountDto";

export enum UnitsFilterType {
    None,
    MaxUnits,
    MinUnits,
    BetweenUnits
}

export type UnitsFilter = {
    type: UnitsFilterType,
    minUnits?: number,
    maxUnits?: number
}

export function parseUnitsFilterDto(dto: UnitsFilterDto) : UnitsFilter {
    let newUnitFilterType : UnitsFilterType;
    if (dto.maxUnits) {
        newUnitFilterType = dto.minUnits 
            ? UnitsFilterType.BetweenUnits
            : UnitsFilterType.MaxUnits;
    }
    else {
        newUnitFilterType = dto.minUnits
            ? UnitsFilterType.MinUnits
            : UnitsFilterType.None;
    }
    const newUnitFilter : UnitsFilter = {
        type: newUnitFilterType,
        maxUnits: dto.maxUnits || undefined,
        minUnits: dto.minUnits || undefined
    }
    return newUnitFilter; 
}

export function unitsFilterToDto(filter: UnitsFilter) : UnitsFilterDto {
    let minUnits : number|undefined = undefined;
    let maxUnits : number|undefined = undefined;
    switch(filter.type) {
        case UnitsFilterType.BetweenUnits:
            minUnits = filter.minUnits;
            maxUnits = filter.maxUnits;
            break;
        case UnitsFilterType.MaxUnits:
            maxUnits = filter.maxUnits;
            break;
        case UnitsFilterType.MinUnits:
            minUnits = filter.minUnits;
            break;
        default:
        case UnitsFilterType.None:
            break;
    }

    return {
        maxUnits: maxUnits,
        minUnits: minUnits
    };
}